import { CONTACT_SUBMITTED_EVENT } from "./meta-contact-conversion";

export function listenForGoogleContactConversion(options: {
  analyticsConsent: boolean;
  measurementId?: string;
  privateArea: boolean;
}) {
  const id = options.measurementId?.trim();
  if (!options.analyticsConsent || options.privateArea || !id || !/^G-[A-Z0-9]{5,}$/i.test(id)) {
    return () => {};
  }
  const onSubmitted = () => {
    try {
      // Only the server-confirmed success event reaches this listener. Never
      // send form values, contact identifiers, a made-up value or an Ads ping.
      window.gtag?.("event", "generate_lead", {
        send_to: id,
        form_id: "contact_quote",
      });
    } catch {
      // Analytics failure must not turn a saved request into a form error.
    }
  };
  window.addEventListener(CONTACT_SUBMITTED_EVENT, onSubmitted);
  return () => window.removeEventListener(CONTACT_SUBMITTED_EVENT, onSubmitted);
}
